/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  IRelayRegistrar,
  IRelayRegistrarInterface,
} from "../IRelayRegistrar";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32[3]",
        name: "relayUrl",
        type: "bytes32[3]",
      },
    ],
    name: "RelayServerRegistered",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
      {
        internalType: "bytes32[3]",
        name: "url",
        type: "bytes32[3]",
      },
    ],
    name: "registerRelayServer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getCreationBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRelayRegistrationMaxAge",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "setRelayRegistrationMaxAge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "getRelayInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "lastSeenBlockNumber",
            type: "uint32",
          },
          {
            internalType: "uint40",
            name: "lastSeenTimestamp",
            type: "uint40",
          },
          {
            internalType: "uint32",
            name: "firstSeenBlockNumber",
            type: "uint32",
          },
          {
            internalType: "uint40",
            name: "firstSeenTimestamp",
            type: "uint40",
          },
          {
            internalType: "bytes32[3]",
            name: "urlParts",
            type: "bytes32[3]",
          },
          {
            internalType: "address",
            name: "relayManager",
            type: "address",
          },
        ],
        internalType: "struct IRelayRegistrar.RelayInfo",
        name: "info",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
    ],
    name: "readRelayInfos",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "lastSeenBlockNumber",
            type: "uint32",
          },
          {
            internalType: "uint40",
            name: "lastSeenTimestamp",
            type: "uint40",
          },
          {
            internalType: "uint32",
            name: "firstSeenBlockNumber",
            type: "uint32",
          },
          {
            internalType: "uint40",
            name: "firstSeenTimestamp",
            type: "uint40",
          },
          {
            internalType: "bytes32[3]",
            name: "urlParts",
            type: "bytes32[3]",
          },
          {
            internalType: "address",
            name: "relayManager",
            type: "address",
          },
        ],
        internalType: "struct IRelayRegistrar.RelayInfo[]",
        name: "info",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "oldestBlockNumber",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "oldestBlockTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxCount",
        type: "uint256",
      },
    ],
    name: "readRelayInfosInRange",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "lastSeenBlockNumber",
            type: "uint32",
          },
          {
            internalType: "uint40",
            name: "lastSeenTimestamp",
            type: "uint40",
          },
          {
            internalType: "uint32",
            name: "firstSeenBlockNumber",
            type: "uint32",
          },
          {
            internalType: "uint40",
            name: "firstSeenTimestamp",
            type: "uint40",
          },
          {
            internalType: "bytes32[3]",
            name: "urlParts",
            type: "bytes32[3]",
          },
          {
            internalType: "address",
            name: "relayManager",
            type: "address",
          },
        ],
        internalType: "struct IRelayRegistrar.RelayInfo[]",
        name: "info",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class IRelayRegistrar__factory {
  static readonly abi = _abi;
  static createInterface(): IRelayRegistrarInterface {
    return new utils.Interface(_abi) as IRelayRegistrarInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IRelayRegistrar {
    return new Contract(address, _abi, signerOrProvider) as IRelayRegistrar;
  }
}
